import { render, staticRenderFns } from "./InboxMessages.vue?vue&type=template&id=3a1dd01c&scoped=true&"
import script from "./InboxMessages.vue?vue&type=script&lang=js&"
export * from "./InboxMessages.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a1dd01c",
  null
  
)

export default component.exports